<risr-list-filter></risr-list-filter>

@if (listResource.state().status === 'loading') {
    <mat-spinner></mat-spinner>
}
@if (listResource.state().status === 'error') {
    <p class="box box-danger" i18n>Unable to load: {{ listResource.state().error }}</p>
}
@if (listResource.state().status === 'resolved') {
    @if (listResource.page()?.items?.length) {
        @for (item of listResource.page()?.items || []; track item.id) {
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
        }
    } @else {
        <div class="empty-state">
            <mat-icon>search_off</mat-icon>
            <p i18n>No items found matching your criteria.</p>
        </div>
    }

    @let totalItems = listResource.page()?.meta?.totalItems || 0;
    <mat-paginator
            risrPaginator
            [length]="totalItems"
            [pageSize]="listResource.pagination()?.pageSize"
            [pageIndex]="listResource.pagination()?.page"
            (page)="updatePage($event)"
            aria-label="Select page">
    </mat-paginator>
}

